import { mutations } from './mutations';
import { getters } from './getters';
import { SessionState } from './state';

const defaultState: SessionState = {
  filtersMap: {},
  advancedSearchVisibleMap: {},
  tableOptionsMap: {},
  choiceCache: {},
  selectedItem: '',
  projectStatusId: null,
  orderDocEventId: null
};

export const sessionModule = {
  state: defaultState,
  mutations,
  getters
};
